/**
 * The react-router adapter for kit components that take a `LinkComponent`
 * (BackLink). The kit hands the adapter `href`; react-router's Link takes
 * `to`. Without it BackLink renders a native anchor, and following it reloads
 * the whole SPA instead of routing inside it.
 *
 * Pledge Detail and Compare Deals built their back links by hand, one a gray
 * text button with the arrow first and the other a red tertiary Button with
 * the arrow last (r3 fi-cons-5, fi-g9-9). Both now render the kit BackLink
 * through this adapter.
 */

import { Link } from 'react-router-dom';
import type { BackLinkComponentProps } from '@aaimplatform/ui';

export function RouterLinkComponent({ href, className, children }: BackLinkComponentProps) {
  return (
    <Link to={href} className={className}>
      {children}
    </Link>
  );
}
